<script>
	import { api } from "./../libs/api.js";
	import { _ } from 'svelte-i18n';

	import { Link } from 'svelte-routing';

	import BaseLayer from "./../components/BaseLayer.svelte";

	let excursions = api.get_all_my_excursions();

	let now = new Date().toISOString();

	function set_accent(string) {
		string = string.replace(/<</g, "<span class=\"text-accent\">")
		string = string.replace(/>>/g, "</span>")
		return string
	}
</script>

<BaseLayer bg="green">
	<div class="text-center">
		<h1 class="page-title pt-20">{$_('excursions.title')}</h1>
		<h2 class="page-title py-10">{$_('excursions.subtitle')}</h2>

		<div class="carousel carousel-center p-4 pt-8 w-full space-x-4 bg-base-100 rounded-t-lg absolute bottom-0">
			{#await excursions}
				<button class="btn btn-secondary w-full loading">{$_('excursions.loading')}</button>
			{:then value}
				{#each value.data as excursion}
				{#await api.get_trail(excursion.excursions_id.trail_id) then trail}
				<div class="carousel-item w-72">
					<div class="card card-compact mb-4 w-full bg-base-100 shadow-xl">

						{#if excursion.excursions_id.date < now}
							<span class="badge badge-warning absolute top-2 right-4 uppercase">{$_('excursions.past')}</span>
						{/if}

						<figure>
							<img class="w-full h-36 object-cover" src="{api.base_url}/assets/{trail.data.cover_image}" alt="{trail.data.title}" />
						</figure>
						<div class="card-body flex-row justify-between">
							<h2 class="card-title">{trail.data.title}</h2>

							<div class="card-actions items-center">
								<Link to="excursions/{excursion.excursions_id.id}">
									<svg class="w-8" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 520 520"><path class="fill-accent" d="M512 256c0-141.4-114.6-256-256-256S0 114.6 0 256c0 141.4 114.6 256 256 256S512 397.4 512 256zM265.9 382.8C259.9 380.3 256 374.5 256 368v-64H160c-17.67 0-32-14.33-32-32v-32c0-17.67 14.33-32 32-32h96v-64c0-6.469 3.891-12.31 9.875-14.78c5.984-2.484 12.86-1.109 17.44 3.469l112 112c6.248 6.248 6.248 16.38 0 22.62l-112 112C278.7 383.9 271.9 385.3 265.9 382.8z"/></svg>
								</Link>
							</div>
						</div>
					</div>
				</div>
				{/await}
				{:else}
					<h3 class="page-title py-10 block">{$_('excursions.no_planned')}</h3>
				{/each}
			{:catch error}
				<div class="fixed top-0 bottom-0 left-0 right-0 bg-black/50 backdrop-blur-md flex flex-col justify-around">
					<div class="w-60 mx-auto">
						<h1 class="page-title pb-8 block text-white">{$_('excursions.oops')}</h1>
						<h3 class="page-title block text-white">
							{@html set_accent( $_('excursions.need_login') )}
						</h3>

						<Link class="btn px-4 py-2 mt-8 !uppercase !font-serif text-2xl btn-accent" to="login">
							{$_('login.login')}
						</Link>

						<h4 class="page-title mt-16 block text-white">
							{@html set_accent( $_('excursions.need_login_explaination') )}
							<a href="https://www.hi-ability.eu/language/en/#contatti"><span class="text-accent"> {$_('excursions.contact_us')} </span></a> {$_('excursions.to_new_group')}
						</h4>
					</div>
				</div>
			{/await}
		</div>
	</div>
</BaseLayer>

